// extracted by mini-css-extract-plugin
export var container = "_dy-0";
export var content = "_dy-3";
export var customerTitle = "_dy-4";
export var empty = "_dy-5";
export var gray = "_dy-6";
export var header = "_dy-7";
export var info = "_dy-8";
export var loading = "_dy-2";
export var loadingCard = "_dy-9";
export var oneLine = "_dy-a";
export var personName = "_dy-e";
export var pillContainer = "_dy-b";
export var selected = "_dy-1";
export var text = "_dy-c";
export var twoLines = "_dy-d";
export var unread = "_dy-f";
export var unreadIndicator = "_dy-g";